import React from 'react'
import { Cpu } from 'lucide-react'

const LoadingSpinner = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 via-white to-secondary-50">
      <div className="text-center">
        <div className="relative">
          <Cpu className="h-16 w-16 text-primary-600 mx-auto animate-pulse" />
          <div className="absolute inset-0 h-16 w-16 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin mx-auto"></div>
        </div>
        <p className="mt-4 text-secondary-700 font-medium">Loading...</p>
      </div>
    </div>
  )
}

export default LoadingSpinner
